import { render, staticRenderFns } from "./clientDisplayNouSomni.vue?vue&type=template&id=4cab2b80&scoped=true&"
import script from "./clientDisplayNouSomni.vue?vue&type=script&lang=js&"
export * from "./clientDisplayNouSomni.vue?vue&type=script&lang=js&"
import style0 from "./clientDisplayNouSomni.vue?vue&type=style&index=0&id=4cab2b80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab2b80",
  null
  
)

export default component.exports